import {
  ChartRangeType,
  getBodyForChartRequest,
  useValidActiveChartRangeType
} from "components";
import { getEndOfDateByTimeUnit, getStartOfDateByTimeUnit } from "helpers";
import { t } from "i18next";
import { ContentLayout } from "layouts";
import { useState } from "react";

import { useStatistic } from "../../api";
import {
  RecentTransactions,
  TopResellers,
  SocialSources,
  StatisticsChart,
  TopSellingCategories,
  TopSellingProducts,
  TopSharedProducts,
  StatisticsOverviewCards
} from "../../components";

import styles from "./Dashboard.module.scss";

const Dashboard = () => {
  const [withComparativePeriod, setWithComparativePeriod] = useState(false);

  const [dateRange, setDateRange] = useState<[Date, Date]>([
    getStartOfDateByTimeUnit(new Date(), ChartRangeType.Week),
    getEndOfDateByTimeUnit(new Date(), ChartRangeType.Week)
  ]);

  const [dateRangeForCompare, setDateRangeForCompare] = useState<[Date, Date]>([
    getStartOfDateByTimeUnit(new Date(), ChartRangeType.Week),
    getEndOfDateByTimeUnit(new Date(), ChartRangeType.Week)
  ]);

  const { activeRangeType } = useValidActiveChartRangeType();

  const { statistic, isLoading } = useStatistic(
    getBodyForChartRequest(dateRange, activeRangeType)
  );

  const { statistic: statisticForCompare, isLoading: isLoadingForCompare } =
    useStatistic(getBodyForChartRequest(dateRangeForCompare, activeRangeType), {
      enabled: withComparativePeriod
    });

  return (
    <ContentLayout title={t("Dashboard")}>
      <StatisticsChart
        totalTitle={t("Total Revenue (FCFA)")}
        titleValue={statistic?.overallProfit}
        comparablePeriodValue={statisticForCompare?.overallProfit}
        isLoading={isLoading}
        isLoadingForCompare={isLoadingForCompare}
        dateRange={dateRange}
        setDateRange={setDateRange}
        withComparativePeriod={withComparativePeriod}
        setWithComparativePeriod={setWithComparativePeriod}
        dateRangeForCompare={dateRangeForCompare}
        setDateRangeForCompare={setDateRangeForCompare}
        chartData={
          statistic?.data.map((item) => ({
            date: item.date,
            value: item.profit
          })) ?? []
        }
      >
        <StatisticsOverviewCards
          statistic={statistic}
          statisticForCompare={statisticForCompare}
          isLoading={isLoading}
          isLoadingForCompare={isLoadingForCompare}
          withComparativePeriod={withComparativePeriod}
        />
      </StatisticsChart>

      <div className={styles.statistics__block}>
        <TopSellingCategories />
        <SocialSources />
      </div>

      <div className={styles.statistics__block}>
        <TopSellingProducts />
        <TopSharedProducts />
      </div>

      <div className={styles.statistics__block}>
        <TopResellers />
        <RecentTransactions />
      </div>
    </ContentLayout>
  );
};

export default Dashboard;
